export default __webpack_public_path__ + "static/media/do_something.0a2861ac.svg";